import React, { useEffect, useRef } from 'react';

import { WIDGET_ID, WIDGET_SRC } from './consts';
import { Iframe } from './styles';

const BookingWidget = () => {
  const iframeRef = useRef(null);

  useEffect(() => {
    const iframe = iframeRef.current;

    if (typeof window === 'undefined' || !iframe) return undefined;

    const config = { measurementIds: [], hasGoogleTagTracking: false, hasFusedeck: false };
    const handleMessage = ({ data }) => {
      if (!data || typeof data !== 'object') return;

      const widgetId = data['od-widget-id'];

      if (widgetId !== WIDGET_ID) return;
      if (data['od-widget-height']) {
        iframe.style.height = `${data['od-widget-height']}px`;
      }
      if (data['od-widget-ios'] === true) {
        iframe.style.width = '100px';
        iframe.style.minWidth = '100%';
        iframe.setAttribute('scrolling', 'no');
      }
      if (data['od-tracking-configs'] !== undefined) {
        config.measurementIds = data['od-tracking-configs'];
      }
      if (data['od-has-google-tag-manager'] !== undefined) {
        config.hasGoogleTagTracking = data['od-has-google-tag-manager'];
      }
      if (data['od-has-fusedeck'] !== undefined) {
        config.hasFusedeck = data['od-has-fusedeck'];
      }

      const ga4 = data.GA4;

      if (!ga4) return;
      if (config.hasGoogleTagTracking && window.dataLayer) {
        window.dataLayer.push({ ...ga4.properties, event: ga4.name });
      }
      if (config.hasFusedeck && window.fdData) {
        window.fdData.push({ ...ga4.properties, event: ga4.name });
      }
      if (typeof window.gtag === 'function') {
        config.measurementIds.forEach((measurementId) => {
          window.gtag('event', ga4.name, { ...ga4.properties, send_to: measurementId });
        });
      }
    };

    window.addEventListener('message', handleMessage);
    iframe.src = WIDGET_SRC;

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);

  return (
    <Iframe
      ref={iframeRef}
      className="od-widget"
      id={`od-widget-${WIDGET_ID}`}
      title="Termin buchen"
      src="about:blank"
      data-src={WIDGET_SRC}
    />
  );
};

export default BookingWidget;
